export const PendingSpinner = () => {
  return (
    <div className="row d-flex h-100 justify-content-center align-items-center">
      <div className="col-sm-12 col-md-8 col-xl-5 center">
        <i className="icon-font tc-icon-spinner-dark" role="status"></i>
      </div>
    </div>
  )
}
